import { render, staticRenderFns } from "./BasicProductReg.vue?vue&type=template&id=8cba96e8&scoped=true"
import script from "./BasicProductReg.vue?vue&type=script&lang=js"
export * from "./BasicProductReg.vue?vue&type=script&lang=js"
import style0 from "./BasicProductReg.vue?vue&type=style&index=0&id=8cba96e8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cba96e8",
  null
  
)

export default component.exports